export const LANGUAGE_COOKIE_KEY = 'nf_country';
export const LANGUAGE_HEADER_KEY = 'x-saved-language';
export const REFRESH_TOKEN_COOKIE_KEY = 'rtoken';
export const DO_NOT_DISPLAY_IN_UI = 'NO_UI';
export const NOT_EXISTING_VALUE = '_____________';
export const DEFAULT_SYNC_GROUP_KEY = 'default';
export const DEFAULT_PRICE_GROUP_KEY = 'default';
